import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('delete-site', {
  template: require('./template.html'),
  name: 'delete-site',
  props: ['current-site', 'toggle-modal', 'modal'],
  mixins: [guid],
  computed: {
    ...mapGetters([
      'priceSource',
      'websites',
      's3EmptyFolderQueue',
      'currentUser',
      'identityId',
    ]),
    totalSavings() {
      let savings = 0;
      _.forEach(this.currentSite.domains, (domain) => {
        if (domain.planPrice) {
          savings += parseFloat(domain.planPrice);
        }
      });
      if (!this.currentSite.exempt) {
        savings += parseFloat(this.currentSite.planPrice);
      }
      return parseFloat(savings).toFixed(2);
    },
  },
  data() {
    return {
      loading: false,
      typeConfirm: '',
      confirmPassed: false,
      deleteErrors: [],
    };
  },
  watch: {
    modal(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  methods: {
    resetModal() {
      this.deleteErrors = [];
      this.loading = false;
      this.typeConfirm = '';
      this.confirmPassed = false;
    },
    async deleteSite() {
      if (this.confirmPassed) {
        this.loading = true;
        const site = _.clone(this.currentSite);
        try {
          const deleteWebsite = await this.$lightning([{
            name: 'deleteWebsite',
            payload: {
              siteId: this.currentSite._id,
            },
          }]);
          this.$log.debug('Successfully deleted website: ', deleteWebsite);
          // then close modal and change routes
          this.closeModal('deleteSite');

          // move back to websites
          setTimeout(() => {
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: 'success',
              message: `Site: ${this.currentSite.alias} successfully deleted!`,
            });
            // we send off to parent component to remove site from state and db
            // so we do not get kicked out of current view
            this.$emit('send-delete', site);
            this.$router.push({ path: '/websites' });
          }, 500);
        } catch (e) {
          this.$log.error('error: ', e);
          this.deleteErrors.push(e.message || e);
          await this._reportError({
            error: e,
            fn: 'deleteSite',
          });
        } finally {
          this.loading = false;
          this._trackEvent({
            type: 'delete_site',
            meta: {
              site_name: site.name,
              site_type: site.type,
              site_tier: site.tier,
              site_id: site._id,
              site_pages: site.pages.length,
              site_templates: site.templates.length,
              site_drafts: site.drafts.length,
              site_forms: site.forms.length,
            },
          });
        }
      }
    },
    confirm() {
      if (this.currentSite.alias === this.typeConfirm) {
        this.confirmPassed = true;
      } else {
        this.confirmPassed = false;
      }
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/delete/index.js